import { mountSplashMark } from './shared/lib/app-loader';

// A route chunk failed to import — usually a stale index.html after a deploy pointing at
// a chunk that no longer exists. Reload once to pick up the new build; the flag (cleared
// in main.tsx on the first render) prevents a reload loop if the import fails for another reason.
window.addEventListener('vite:preloadError', (event) => {
	if (sessionStorage.getItem('chunk-reload-attempted')) return;
	event.preventDefault();
	sessionStorage.setItem('chunk-reload-attempted', '1');
	window.location.reload();
});

void import('./main');

mountSplashMark();
